import React from 'react'
import { Link } from 'react-router-dom'

import agent from 'agent'
import { AlertText } from 'components/common/Alert'
import Button from 'components/common/Button'
import { ConfirmationModal } from 'components/common/ConfirmationModal'
import Text from 'components/common/Text'
import { trans } from 'i18n/translate'
import toast from 'lib/toast'
import { track } from 'track'
import { messageFromResponseError } from 'utils/strings'

async function shareScenario(scenarioId, currentTeamId) {
  try {
    track('ScenarioShared', {
      category: 'ScenarioSharing',
      count: 1
    })

    const { data } = await agent.post(
      `scenarios/shared?teamId=${currentTeamId}`,
      [scenarioId]
    )

    const result = data[scenarioId]

    if (result.status !== 'SUCCESS') {
      throw new Error('Failed to create shared scenario')
    }

    toast({
      type: 'success',
      text: (
        <AlertText>This Scenario has been shared with your company. </AlertText>
      ),
      action: (
        <Button
          primary
          as={Link}
          to={`/scenarios/shared/company/${result.sharedId}`}
        >
          View Scenario
        </Button>
      )
    })
  } catch (err) {
    toast({
      type: 'error',
      text: messageFromResponseError(
        err,
        'There was an issue sharing this scenario. Please try again later.'
      )
    })
  }
}

export const ShareScenarioModal: React.FC<{
  scenarioId: string
  currentTeamId: string
  open: boolean
  onConfirm(): void
  onCancel(): void
}> = ({ scenarioId, currentTeamId, open, onConfirm, onCancel }) => {
  return (
    <ConfirmationModal
      confirmButtonType="primary"
      confirmText="Share"
      message={
        <>
          <Text as="p">
            {trans('scenarios.share_scenario_modal.message.paragraph_one')}
          </Text>
          <br />
          <Text as="p">
            {trans('scenarios.share_scenario_modal.message.paragraph_two')}
          </Text>
        </>
      }
      open={open}
      title={trans('scenarios.share_scenario_modal.title')}
      onCancel={onCancel}
      onConfirm={async () => {
        await shareScenario(scenarioId, currentTeamId)
        onConfirm()
      }}
    />
  )
}
